<template lang="pug">
  b-modal#editPromotion(
    ref="editPromotion"
    :title="$t('ui.edit_promotion')"
    centered
    no-fade
    no-close-on-backdrop
    :busy="loading"
    @ok="done"
    @show="reset"
    @shown="shown"
  )
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$t('ui.promo_id')").mb-0
        DebounceInput(
          size="sm"
          type="text"
          :value="pid"
          disabled
        )
      b-form-group(:label="$t('ui.promo_name')").mb-0
        DebounceInput(
          ref="edit_promoName"
          size="sm"
          required
          type="text"
          :dirty="$v.edit_promoName.$dirty"
          :error="$v.edit_promoName.$error"
          v-model.trim.lazy="$v.edit_promoName.$model"
          :disabled="loading"
          :maxLength="$v.edit_promoName.$params.maxLength.max"
          @keyup.enter.native="submit"
        )
        ValidateResult(:value="$v.edit_promoName" :name="$t('ui.promo_name')")
      b-form-group(:label="$t('ui.promo_desc')").mb-0
        DebounceInput(
          size="sm"
          type="text"
          :dirty="$v.edit_promoDesc.$dirty"
          :error="$v.edit_promoDesc.$error"
          v-model.trim.lazy="$v.edit_promoDesc.$model"
          :disabled="loading"
          :maxLength="$v.edit_promoDesc.$params.maxLength.max"
          @keyup.enter.native="submit"
        )
        ValidateResult(:value="$v.edit_promoDesc" :name="$t('ui.promo_desc')")
      div.row
        div.col
          b-alert.animated.bounceIn(v-bind:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      i.fa.fa-ban
      span {{ $t("ui.cancel") }}
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, minLength, maxLength, helpers } from "vuelidate/lib/validators"
import config from "@/config"
import errorTags from "@/errorTags"
import SubmitButton from "@/library/SubmitButton"
import ValidateResult from "@/library/ValidateResult"
import DebounceInput from "@/library/DebounceInput"

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    pid: "",
    pname: "",
    pdesc: ""
  },
  data() {
    return {
      edit_promoName: "",
      edit_promoDesc: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  validations: {
    edit_promoName: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(50)
    },
    edit_promoDesc: {
      maxLength: maxLength(50)
    }
  },
  watch: {
    pname: function(newVal) {
      this.edit_promoName = newVal;
    },
    pdesc: function(newVal) {
      this.edit_promoDesc = newVal;
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loading = true
        this.$swal({
          title: this.$t("ui.status"),
          text: this.$t("message.edit_promotion_confirm"),
          type: "warning",
          showCancelButton: true,
          allowOutsideClick: false
        }).then(result => {
          if (result.value) {
            this.editPromotion()
          } else if (
            // Read more about handling dismissals
            result.dismiss === this.$swal.DismissReason.cancel
          ) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.cancel"),
              text: this.$t("message.edit_promotion_cancel"),
              type: "error",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        });
      }
    },
    editPromotion: function() {
      let promo_id = this.pid
      let promo_name = this.edit_promoName
      let promo_desc = this.edit_promoDesc
      this.loading = true;
      this.$store
        .dispatch("promotion/updatePromotion", { promo_id, promo_name, promo_desc })
        .then(response => {
          this.loading = false;
          this.feedback.success = response.success;
          this.feedback.status = response.status;
          if (this.feedback.success == true) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.succeed"),
              text: this.$t("message.edit_promotion_success"),
              type: "success",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        })
        .catch(response => {
          this.loading = false;
          this.feedback.success = response.success
          this.feedback.status = this.$t("message." + response.errorTag)
        });
    },
    reset: function() {
      this.edit_promoID = this.pid
      this.edit_promoName = this.pname
      this.edit_promoDesc = this.pdesc
      this.feedback.success = true
      this.feedback.status = ""
    },
    shown: function() {
      this.$nextTick(() => {
        this.$v.$reset()
      })
      this.$refs.edit_promoName.$el.focus()
    },
    cancel: function() {
      this.$emit("clicked")
      this.$refs.editPromotion.hide()
    }
  }
};
</script>
